var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 16.826,
    height: 16.914,
    viewBox: "0 0 16.826 16.914",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-930.466 -146.324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M931.763,156.75l-4.252,1.874-4.461-1.3-2.583-3.862.5-4.619,3.355-3.215,4.636-.306,3.748,2.745,1.107,4.512Z",
    transform: "translate(11 2)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.798,
    y2: 2.926,
    transform: "translate(943.08 158.899)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.045,0A6.045,6.045,0,1,1,0,6.045,6.045,6.045,0,0,1,6.045,0Z",
    transform: "translate(932.018 147.851)",
    fill: "none",
    stroke: "#324655",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.e8df2a6a.svg";
export { ForwardRef as ReactComponent };